import { render } from "./RecursiveTable.vue?vue&type=template&id=59a15766"
import script from "./RecursiveTable.vue?vue&type=script&lang=js"
export * from "./RecursiveTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__